import { createContext, use } from 'react';
import { useAnalytics } from '@/services/analytics';

export type VideoLibraryTrack = ReturnType<typeof useAnalytics>['track'];

/**
 * Managed modals render at the PlumaProvider level, above the workspace
 * context `useAnalytics` reads from (its `track` silently no-ops without a
 * workspace). `VideoLibraryProvider` therefore passes its own `track` — bound
 * below those contexts — into the modal via `data`, and the modal re-provides
 * it here for the directory/viewer components.
 */
export const VideoLibraryTrackContext = createContext<VideoLibraryTrack | null>(null);

/** The modal-provided `track` when inside the video library modal, otherwise `useAnalytics`'s. */
export function useVideoLibraryTrack(): VideoLibraryTrack {
  const contextTrack = use(VideoLibraryTrackContext);
  const { track } = useAnalytics();
  return contextTrack ?? track;
}
